module.exports = __webpack_public_path__ + "ci_vendor_zenius.46b39.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/ci_vendor_zenius.svg
// module id = ./src/_asset/sources/assets/images/@svg/ci_vendor_zenius.svg
// module chunks = main